var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_vm._m(0),_c('ul',{staticClass:"user-account"},[_c('li',[_c('a',[_c('img',{staticClass:"avatar",attrs:{"src":require("@/assets/no-image.png"),"alt":"Profile"}}),_vm._v("\n        "+_vm._s(_vm.user ? _vm.user.fullname : ""))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-title"},[_c('h3',[_vm._v("HPU")])])
}]

export { render, staticRenderFns }